import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import type { SavedCommodity } from "@freightsimple/generated-dashboard-openapi-client/models/SavedCommodity";
import { BookShipmentSavedCommodityPicker } from "./BookShipmentSavedCommodityPicker";

interface SelectInitialSavedCommodityProps {
  savedCommodities: Array<SavedCommodity>;
  onSomethingElse: () => void;
  onSelectSavedCommodity: (_: SavedCommodity) => void;
}

export function BookShipmentSelectInitialSavedCommodity(
  props: SelectInitialSavedCommodityProps,
) {
  return (
    <Panel collapseOnNarrow>
      <BookShipmentSavedCommodityPicker
        savedCommodities={props.savedCommodities}
        onSelectSavedCommodity={props.onSelectSavedCommodity}
        onSomethingElse={props.onSomethingElse}
      />
    </Panel>
  );
}
